import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=65018edf&scoped=true&"
import script from "./Agreement.vue?vue&type=script&lang=ts&"
export * from "./Agreement.vue?vue&type=script&lang=ts&"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=65018edf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65018edf",
  null
  
)

export default component.exports